import { render, staticRenderFns } from "./ButtonBuyTicket.vue?vue&type=template&id=55a9771c&scoped=true&lang=pug"
import script from "./ButtonBuyTicket.vue?vue&type=script&lang=js"
export * from "./ButtonBuyTicket.vue?vue&type=script&lang=js"
import style0 from "./ButtonBuyTicket.vue?vue&type=style&index=0&id=55a9771c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9771c",
  null
  
)

export default component.exports